module.exports = __webpack_public_path__ + "static/img/finger.3b522e4a.gif";